import { useState } from "react";
import FilterType from "components/TableFilters/FilterType";
import { FilterFields } from "stores/StatusStore";
import {
  ColumnItems,
  FilterChip,
  FilterChips,
  FiltersData,
} from "components/TableFilters/TableFilters";
import { useTranslation } from "react-i18next";

// utils
import { formatDateForFilters, formatDateForRequest } from "utilities/helpers";
interface TFProps {
  store: {
    filters: FilterChip[];
    addFilter: (value: FilterChip) => void;
    removeFilter: (index: number) => void;
    fetchStatus: (params: { pageNumber: number; take: number }) => void;
  };
  //   stateTypes: string[];
}

const StatusTableFilters = (props: TFProps): FiltersData => {
  const { store } = props;
  const [severity, setSeverity] = useState("");
  const [selectedHeartbeatDate, setSelectedHeartbeatDate] =
    useState<Date | null>(null);
  const [name, setName] = useState("");
  const { t } = useTranslation();

  const filters: FilterType[] = [
    {
      type: "select",
      id: "severity",
      columnNumber: 0,
      chipDescription: `${t("severity")}: ${severity}`,
      selectProps: {
        label: t("severity"),
        value: severity,
        selectOptions: [
          {
            label: `${t("normal")}`,
            value: "Normal",
          },
          {
            label: `${t("warning")}`,
            value: "Warning",
          },
          {
            label: `${t("error")}`,
            value: "Error",
          },
        ],
        onChange: (e: any) => {
          setSeverity(e.target.value);
        },
        width: "100%",
      },
      onApply: () => {
        if (severity.length > 0)
          store.addFilter({
            id: FilterFields.Severity,
            chipDescription: `${t("severity")}:   ${severity}`,
            value: severity,
            onRemove: (i) => {
              store.removeFilter(i);
              store.fetchStatus({
                pageNumber: 1,
                take: 10,
              });
            },
          });
        setSeverity("");
        store.fetchStatus({ pageNumber: 1, take: 10 });
      },
    },

    {
      type: "date",
      id: "date",
      chipDescription: t("heartbeat"),
      columnNumber: 1,
      datePickerProps: {
        value: selectedHeartbeatDate || null,
        label: t("date"),
        onChange: (value) => {
          setSelectedHeartbeatDate(value);
        },
      },
      onApply: () => {
        if (selectedHeartbeatDate) {
          const justDate = new Date(selectedHeartbeatDate);
          store.addFilter({
            id: FilterFields.Heartbeat,
            chipDescription: `${t("heartbeat")}: ${formatDateForFilters(
              justDate
            )}`,
            value: formatDateForFilters(justDate),
            onRemove: (i) => {
              store.removeFilter(i);
              setSelectedHeartbeatDate(null);
              store.fetchStatus({
                pageNumber: 1,
                take: 10,
              });
            },
          });
        }
        store.fetchStatus({ pageNumber: 1, take: 10 });
      },
    },
    {
      type: "textfields",
      id: "name",
      columnNumber: 2,
      chipDescription: ["name"],
      inputProps: [
        {
          label: "Search by name",
          defaultValue: name,
          onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
            console.log(
              "🚀 ~ file: StatusTableFilters.tsx:121 ~ StatusTableFilters ~ e.currentTarget.value:",
              e.currentTarget.value
            );
            setName(e.currentTarget.value);
          },
          autoFocus: true,
        },
      ],
      onApply: () => {
        if (name.length > 0)
          store.addFilter({
            id: FilterFields.Name,
            chipDescription: `${t("name")}: ${name}`,
            value: name,
            onRemove: (i) => {
              store.removeFilter(i);
              store.fetchStatus({
                pageNumber: 1,
                take: 10,
              });
            },
          });
        setName("");
        store.fetchStatus({ pageNumber: 1, take: 10 });
      },
    },
  ];

  return {
    current: FilterChips(store.filters),
    contentIcons: ColumnItems(filters),
  };
};

export default StatusTableFilters;
